import { useEffect, useState, useCallback } from "react";
import api from "../api/api";
import {
  Paper, Typography, Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Table, TableHead, TableRow, TableCell, TableBody, Chip, MenuItem
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export default function AdminRoles() {
  const [roles, setRoles] = useState([]);
  const [permisos, setPermisos] = useState([]);

  const [openNew, setOpenNew] = useState(false);
  const [newRole, setNewRole] = useState({ nombre_rol: "", descripcion: "" });

  const [openPerms, setOpenPerms] = useState(false);
  const [selRol, setSelRol] = useState(null);
  const [permToAdd, setPermToAdd] = useState("");

  const cargar = useCallback(async () => {
    const [rRes, pRes] = await Promise.all([
      api.get("/admin/roles"),
      api.get("/admin/roles/permisos")
    ]);
    setRoles(rRes.data);
    setPermisos(pRes.data);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const crear = async () => {
    if (!newRole.nombre_rol.trim()) return alert("Enter the role name");
    await api.post("/admin/roles", newRole);
    setOpenNew(false);
    setNewRole({ nombre_rol: "", descripcion: "" });
    cargar();
  };

  const eliminar = async (idRol) => {
    try {
      await api.delete(`/admin/roles/${idRol}`);
      cargar();
    } catch {
      alert("Cannot delete: role in use or missing permission.");
    }
  };

  const abrirPermisos = (rol) => { setSelRol(rol); setOpenPerms(true); setPermToAdd(""); };

  const asignarPermiso = async () => {
    if (!permToAdd) return;
    await api.post(`/admin/roles/${selRol.id_rol}/permisos`, { id_permiso: parseInt(permToAdd) });
    cargar();
  };

  const quitarPermiso = async (codigo) => {
    const perm = permisos.find(p => p.codigo === codigo);
    if (!perm) return;
    await api.delete(`/admin/roles/${selRol.id_rol}/permisos/${perm.id_permiso}`);
    cargar();
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Role & Permission Administration</Typography>

      <Button variant="contained" startIcon={<AddIcon />} sx={{ mb: 2 }} onClick={() => setOpenNew(true)}>
        New Role
      </Button>

      <Table>
        <TableHead>
          <TableRow sx={{ background: "#000" }}>
            <TableCell sx={{ color: "white" }}>Role</TableCell>
            <TableCell sx={{ color: "white" }}>Description</TableCell>
            <TableCell sx={{ color: "white" }}>Permissions</TableCell>
            <TableCell sx={{ color: "white" }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {roles.map(r => (
            <TableRow key={r.id_rol}>
              <TableCell>{r.nombre_rol}</TableCell>
              <TableCell>{r.descripcion || "-"}</TableCell>
              <TableCell>
                {r.permisos.length
                  ? r.permisos.map((c, idx) => (
                      <Chip key={idx} label={c} onDelete={() => { setSelRol(r); quitarPermiso(c); }} sx={{ mr: 1, mb: 1 }} />
                    ))
                  : "-"}
              </TableCell>
              <TableCell>
                <Button size="small" onClick={() => abrirPermisos(r)}>Edit permissions</Button>
                <Button size="small" color="error" startIcon={<DeleteIcon />} onClick={() => eliminar(r.id_rol)}>Delete</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* New Role dialog */}
      <Dialog open={openNew} onClose={() => setOpenNew(false)}>
        <DialogTitle>New Role</DialogTitle>
        <DialogContent>
          <TextField label="Role name" fullWidth sx={{ mt: 1 }} value={newRole.nombre_rol} onChange={e => setNewRole({ ...newRole, nombre_rol: e.target.value })} />
          <TextField label="Description" fullWidth sx={{ mt: 2 }} value={newRole.descripcion} onChange={e => setNewRole({ ...newRole, descripcion: e.target.value })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenNew(false)}>Cancel</Button>
          <Button variant="contained" onClick={crear}>Create</Button>
        </DialogActions>
      </Dialog>

      {/* Permissions by role dialog */}
      <Dialog open={openPerms} onClose={() => setOpenPerms(false)}>
        <DialogTitle>Permissions for role: {selRol?.nombre_rol}</DialogTitle>
        <DialogContent>
          <TextField select label="Add permission" fullWidth value={permToAdd} onChange={e => setPermToAdd(e.target.value)} sx={{ mt: 1 }}>
            {permisos.map(p => (
              <MenuItem key={p.id_permiso} value={p.id_permiso}>
                {p.codigo}
              </MenuItem>
            ))}
          </TextField>

          <Typography sx={{ mt: 2, mb: 1 }}>Current permissions:</Typography>
          {selRol?.permisos?.length
            ? selRol.permisos.map((c, idx) => (
                <Chip key={idx} label={c} onDelete={() => quitarPermiso(c)} sx={{ mr: 1, mb: 1 }} />
              ))
            : <Typography>No permissions</Typography>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPerms(false)}>Close</Button>
          <Button variant="contained" onClick={asignarPermiso}>Assign</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}
